import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { setRead } from 'shared/api/socket.api'

const socketSlice = createSlice({
  name: 'socket',
  initialState: {
    status: 'Connecting' as string,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(socketStatusUpdate.fulfilled, (state, { payload }) => {
      state.status = payload
    })
  },
})

export const socketStatusUpdate = createAsyncThunk(
  'socket/socketStatusUpdate',
  async (status: string) => {
    return status
  }
)

export const setSocketMessageAsRead = createAsyncThunk(
  'socket/setSocketMessageAsRead',
  (id: string) => {
    setRead(id)
  }
)

export const { reducer } = socketSlice
